import { useContext } from 'react'

import { PensionContext } from '@/contexts/PensionContext'

export const usePension = () => useContext(PensionContext)
